import { axiosInstance } from '@/plugins/axios';

export default {
	namespaced: true,
	state: {
    plansCategories: {},
		plans: {},
    plan: {},
    isPremium: false,
	},
	getters: {
    plansCategories(state) {
			return state.plansCategories;
		},
		plans(state) {
			return state.plans;
		},
    plan(state) {
			return state.plan;
		},
    isPremium(state) {
      return state.isPremium;
    }
	},
	mutations: {
    SET_PLANS_CATEGORIES(state, value) {
			state.plansCategories = value;
		},
		SET_PLANS(state, value) {
			state.plans = value;
		},
    SET_PLAN(state, value) {
			state.plan = value;
		},
    SET_IS_PREMIUM(state, value) {
			state.isPremium = value;
		},
	},
	actions: {
    async registerCategoryPlans(context, value) {
      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('name', value.name);

      const url = value.id ? `plans/categories/${value.id}` : 'plans/categories';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultCategoriesPlans');
        })
    },
    async consultCategoriesPlans(context){
      await axiosInstance({
        method: 'GET',
        url: 'plans/categories',
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_PLANS_CATEGORIES', data]);
        })
    },
    async removeCategoryPlans(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `plans/categories/${id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultCategoriesPlans');
        })
    },
    async registerPlan(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('id_plan_category', value.id_plan_category);
      formData.append('name', value.name);
      formData.append('title', value.title);
      formData.append('description', value.description);
      formData.append('contentHtml', value.contentHtml);
      formData.append('picture', value.picture);
      formData.append('is_premium', value.is_premium);

      const url = value?.id ? `plans/${value.id}` : 'plans';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultPlans');
        })
    },
    async consultPlans(context, value){
      const url = value?.id ? `plans/${value.id}` : 'plans';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.id) {
            context.dispatch('setDataDefault', ['SET_PLAN', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_PLANS', data]);
        })
    },
    async removePlan(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `plans/${id}`,
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_PLANS', data]);
        })
    },
    setDataDefault(context, [mutationName, value]){
      context.commit(`${mutationName}`, value);
    },
	}
}
